import React, { useState, useEffect } from "react";

// reactstrap components
import { Button, Container, Row, Col } from "reactstrap";

// core components

function SectionNucleoIcons() {
  const [isVisible, setIsVisible] = useState(false);
  const [particleCount, setParticleCount] = useState(50);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      <div id="tri-influencer-section" style={{
        background: 'linear-gradient(135deg, #7C3AED 0%, #EC4899 100%)',
        padding: '120px 0',
        position: 'relative',
        overflow: 'hidden',
        minHeight: '100vh',
        display: 'flex',
        alignItems: 'center'
      }}>
        {/* Animated Background Particles */}
        {[...Array(particleCount)].map((_, i) => (
          <div
            key={i}
            style={{
              position: 'absolute',
              width: Math.random() * 6 + 2 + 'px',
              height: Math.random() * 6 + 2 + 'px',
              background: `rgba(255, 255, 255, ${Math.random() * 0.8 + 0.2})`,
              borderRadius: '50%',
              left: Math.random() * 100 + '%',
              top: Math.random() * 100 + '%',
              animation: `float ${Math.random() * 10 + 10}s infinite linear`,
              animationDelay: Math.random() * 10 + 's'
            }}
          />
        ))}

        {/* Floating Social Media Icons */}
        <div style={{
          position: 'absolute',
          top: '10%',
          left: '5%',
          animation: 'bounce 3s infinite'
        }}>
          <i className="fa fa-instagram" style={{ 
            fontSize: '30px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 2s infinite'
          }} />
        </div>
        <div style={{
          position: 'absolute',
          top: '20%',
          right: '8%',
          animation: 'bounce 3s infinite 1s'
        }}>
          <i className="fa fa-youtube-play" style={{ 
            fontSize: '35px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 2s infinite 0.5s'
          }} />
        </div>
        <div style={{
          position: 'absolute',
          bottom: '15%',
          left: '10%',
          animation: 'bounce 3s infinite 2s'
        }}>
          <i className="fa fa-tiktok" style={{ 
            fontSize: '25px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 2s infinite 1s'
          }} />
        </div>
        <div style={{
          position: 'absolute',
          bottom: '25%',
          right: '5%',
          animation: 'bounce 3s infinite 0.5s'
        }}>
          <i className="fa fa-twitter" style={{ 
            fontSize: '28px', 
            color: 'rgba(255,255,255,0.3)',
            animation: 'pulse 2s infinite 1.5s'
          }} />
        </div>

        {/* Gradient Orbs */}
        <div style={{
          position: 'absolute',
          top: '-100px',
          right: '-100px',
          width: '300px',
          height: '300px',
          background: 'radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'rotate 20s linear infinite'
        }}></div>
        <div style={{
          position: 'absolute',
          bottom: '-150px',
          left: '-150px',
          width: '400px',
          height: '400px',
          background: 'radial-gradient(circle, rgba(240, 147, 251, 0.1) 0%, transparent 70%)',
          borderRadius: '50%',
          animation: 'rotate 25s linear infinite reverse'
        }}></div>

        <Container style={{ position: 'relative', zIndex: 2 }}>
          <Row className="align-items-center">
            <Col lg="6" md="12" style={{ 
              transform: isVisible ? 'translateX(0)' : 'translateX(-100px)',
              opacity: isVisible ? 1 : 0,
              transition: 'all 1s ease-out'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.1)',
                borderRadius: '30px',
                padding: '60px 40px',
                backdropFilter: 'blur(20px)',
                border: '1px solid rgba(255,255,255,0.2)',
                boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
                position: 'relative',
                overflow: 'hidden'
              }}>
                {/* Decorative Elements */}
                <div style={{
                  position: 'absolute',
                  top: '-50px',
                  right: '-50px',
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                  borderRadius: '50%',
                  opacity: 0.3
                }}></div>
                <div style={{
                  position: 'absolute',
                  bottom: '-30px',
                  left: '-30px',
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                  borderRadius: '50%',
                  opacity: 0.3
                }}></div>

                <div style={{ position: 'relative', zIndex: 2 }}>
                  <h2 style={{
                    color: 'white',
                    fontSize: '4rem',
                    fontWeight: '800',
                    marginBottom: '30px',
                    textShadow: '0 4px 8px rgba(0,0,0,0.3)',
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57, #4facfe)',
                    WebkitBackgroundClip: 'text',
                    WebkitTextFillColor: 'transparent',
                    backgroundClip: 'text'
                  }}>
                    Tri-Influencer
                  </h2>

                  <div style={{
                    width: '100px',
                    height: '4px',
                    background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                    marginBottom: '30px',
                    borderRadius: '2px'
                  }}></div>

                  <p style={{ 
                    color: 'rgba(255,255,255,0.9)', 
                    fontSize: '1.3rem', 
                    fontWeight: '400',
                    lineHeight: '1.8',
                    marginBottom: '40px',
                    textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                  }}>
                    🌟 <strong>We gladly present our revolutionary service, Influencers Startup!</strong>
                    <br /><br />
                    With Tri-Influencer, you can achieve your dream of becoming an influencer on social media. 
                    It is the <span style={{ color: '#feca57', fontWeight: '600' }}>first service available worldwide</span> for anyone aged 15+ who dreams of celebrity, millions of followers, and more.
                    <br /><br />
                    We guarantee <span style={{ color: '#ff6b6b', fontWeight: '600' }}>thousands of followers</span> in the early stages of the program, while <span style={{ color: '#4facfe', fontWeight: '600' }}>millions will certainly be your destiny</span>.
                  </p>

                  <div style={{ display: 'flex', gap: '20px', flexWrap: 'wrap' }}>
                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #ff6b6b, #feca57)',
                        border: 'none',
                        padding: '18px 40px',
                        borderRadius: '30px',
                        color: 'white',
                        fontWeight: '700',
                        fontSize: '1.2rem',
                        boxShadow: '0 10px 30px rgba(255, 107, 107, 0.4)',
                        transition: 'all 0.3s ease',
                        position: 'relative',
                        overflow: 'hidden'
                      }}
                      href="https://www.instagram.com/tri_nfluencer/?igshid=YmMyMTA2M2Y%3D"
                      target="_blank"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.boxShadow = '0 15px 40px rgba(255, 107, 107, 0.6)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 10px 30px rgba(255, 107, 107, 0.4)';
                      }}
                    >
                      <i className="fa fa-instagram" style={{ marginRight: '10px' }} />
                      Join Tri-Influencer
                    </Button>

                    <Button
                      className="btn-round"
                      style={{
                        background: 'linear-gradient(45deg, #4facfe, #00f2fe)',
                        border: 'none',
                        padding: '18px 40px',
                        borderRadius: '30px',
                        color: 'white',
                        fontWeight: '700',
                        fontSize: '1.2rem',
                        boxShadow: '0 10px 30px rgba(79, 172, 254, 0.4)',
                        transition: 'all 0.3s ease'
                      }}
                      href="#contact"
                      onMouseEnter={(e) => {
                        e.target.style.transform = 'scale(1.05)';
                        e.target.style.boxShadow = '0 15px 40px rgba(79, 172, 254, 0.6)';
                      }}
                      onMouseLeave={(e) => {
                        e.target.style.transform = 'scale(1)';
                        e.target.style.boxShadow = '0 10px 30px rgba(79, 172, 254, 0.4)';
                      }}
                    >
                      <i className="fa fa-rocket" style={{ marginRight: '10px' }} />
                      Start Your Journey
                    </Button>
                  </div>

                  {/* Stats */}
                  <div style={{ 
                    display: 'flex', 
                    gap: '40px', 
                    marginTop: '50px',
                    flexWrap: 'wrap'
                  }}>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        color: '#feca57',
                        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                      }}>15+</div>
                      <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem' }}>Minimum Age</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        color: '#ff6b6b',
                        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                      }}>1000+</div>
                      <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem' }}>Guaranteed Followers</div>
                    </div>
                    <div style={{ textAlign: 'center' }}>
                      <div style={{
                        fontSize: '2.5rem',
                        fontWeight: '800',
                        color: '#4facfe',
                        textShadow: '0 2px 4px rgba(0,0,0,0.3)'
                      }}>∞</div>
                      <div style={{ color: 'rgba(255,255,255,0.8)', fontSize: '1rem' }}>Your Potential</div>
                    </div>
                  </div>
                </div>
              </div>
            </Col>

            <Col lg="6" md="12" style={{ 
              transform: isVisible ? 'translateX(0)' : 'translateX(100px)',
              opacity: isVisible ? 1 : 0,
              transition: 'all 1s ease-out 0.3s'
            }}>
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                position: 'relative'
              }}>
                {/* Main Image Container */}
                <div style={{
                  position: 'relative',
                  borderRadius: '30px',
                  overflow: 'hidden',
                  boxShadow: '0 30px 60px rgba(0,0,0,0.3)',
                  transform: 'perspective(1000px) rotateY(-5deg) rotateX(5deg)',
                  transition: 'all 0.3s ease'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'perspective(1000px) rotateY(0deg) rotateX(0deg) scale(1.05)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'perspective(1000px) rotateY(-5deg) rotateX(5deg) scale(1)';
                }}>
                  <img
                    alt="Tri-Influencer"
                    className="img-rounded img-responsive"
                    src={require("assets/img/faces/f.png").default}
                    style={{
                      width: '100%',
                      height: 'auto',
                      borderRadius: '30px',
                      filter: 'brightness(1.1) contrast(1.1)'
                    }}
                  />
                  
                  {/* Overlay Effects */}
                  <div style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    background: 'linear-gradient(45deg, rgba(255,107,107,0.1), rgba(254,202,87,0.1), rgba(79,172,254,0.1))',
                    borderRadius: '30px',
                    pointerEvents: 'none'
                  }}></div>
                </div>

                {/* Floating Elements Around Image */}
                <div style={{
                  position: 'absolute',
                  top: '10%',
                  left: '-20px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  width: '60px',
                  height: '60px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(10px)',
                  animation: 'float 3s ease-in-out infinite'
                }}>
                  <i className="fa fa-heart" style={{ color: '#ff6b6b', fontSize: '20px' }} />
                </div>
                <div style={{
                  position: 'absolute',
                  top: '20%',
                  right: '-30px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  width: '80px',
                  height: '80px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(10px)',
                  animation: 'float 3s ease-in-out infinite 1s'
                }}>
                  <i className="fa fa-star" style={{ color: '#feca57', fontSize: '25px' }} />
                </div>
                <div style={{
                  position: 'absolute',
                  bottom: '15%',
                  left: '-25px',
                  background: 'rgba(255,255,255,0.2)',
                  borderRadius: '50%',
                  width: '70px',
                  height: '70px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  backdropFilter: 'blur(10px)',
                  animation: 'float 3s ease-in-out infinite 2s'
                }}>
                  <i className="fa fa-trophy" style={{ color: '#4facfe', fontSize: '22px' }} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* CSS Animations */}
        <style jsx>{`
          @keyframes float {
            0%, 100% { transform: translateY(0px); }
            50% { transform: translateY(-20px); }
          }
          @keyframes bounce {
            0%, 20%, 50%, 80%, 100% { transform: translateY(0); }
            40% { transform: translateY(-10px); }
            60% { transform: translateY(-5px); }
          }
          @keyframes pulse {
            0% { transform: scale(1); }
            50% { transform: scale(1.1); }
            100% { transform: scale(1); }
          }
          @keyframes rotate {
            from { transform: rotate(0deg); }
            to { transform: rotate(360deg); }
          }
        `}</style>
      </div>
    </>
  );
}

export default SectionNucleoIcons;